import { Auth } from 'aws-amplify';
import axios from 'axios';
import { useCallback } from 'react';

import { getEnvVar } from '@utils/environmentVariables';

import { useClearAppData } from './useClearAppData';

export const useLogout = () => {
  const { clearAppData } = useClearAppData();

  const logoutForgerock = useCallback(async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const idToken = await user?.signInUserSession?.idToken?.payload['custom:preferredMode'];
      const logoutConfig = {
        Method: 'get',
        url: getEnvVar('NEXT_PUBLIC_FORGEROCK_LOGOUT'),
        headers: {
          'Content-Type': 'application/json',
          idToken,
          redirectURI: process.env.NEXT_PUBLIC_FORGEROCK_REDIRECT_URI,
          'x-api-key': process.env.NEXT_PUBLIC_FORGEROCK_API_KEY,
        },
      };
      await axios(logoutConfig);
    } catch (error) {
      console.log(error);
    }
    await Auth.signOut({ global: false });
    clearAppData();
  }, [clearAppData]);

  return { logoutForgerock };
};
